// extracted by mini-css-extract-plugin
module.exports = {"CludoSearchResults":"cludoSearchResults_CludoSearchResults__2fTUJ","CludoSearchResults_heading":"cludoSearchResults_CludoSearchResults_heading__25Aio"};